export default {
  header: 'Are you sure you want to delete this payment method?',
  delete: 'Delete',
};
